import { render } from "./IndexTopbarButton.vue?vue&type=template&id=7e18e640&scoped=true"
import script from "./IndexTopbarButton.vue?vue&type=script&lang=js"
export * from "./IndexTopbarButton.vue?vue&type=script&lang=js"

import "./IndexTopbarButton.vue?vue&type=style&index=0&id=7e18e640&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e18e640"]])

export default __exports__